<template>
  <div class="uk-background-cover uk-height-1-1 layout-background uk-text-left">
    <div
      class="uk-grid-collapse"
      uk-grid
    >
      <sidebar
        :role-type="user?.role?.name?.toUpperCase() || ''"
        :sidebar-open="sidebarOpen"
        @toggle-sidebar="toggleSidebar"
      />
      <div class="uk-width-expand@s">
        <header-default
          :role-type="user?.role?.name?.toUpperCase() || ''"
          @toggle-sidebar="toggleSidebar"
        />
        <router-view />
      </div>
    </div>
    <modal-terms-condition
      v-if="user?.is_first_time_login"
      :user="user"
      :is-valid-terms="user?.is_first_time_login"
    />
  </div>
</template>

<script>
import HeaderDefault from "@/components/globals/header/Default"
import Sidebar from "@/components/globals/sidebar"
import ModalTermsCondition from "@/components/globals/modal/ModalTermsCondition"
import { getUserProfile } from "@/utils/auth"

export default {
  components: {
    HeaderDefault,
    Sidebar,
    ModalTermsCondition
  },
  data() {
    return {
      sidebarOpen: true,
      isMobile: false
    }
  },
  computed: {
    user() {
      return getUserProfile()
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener("resize", this.checkMobile)
    this.$store.dispatch("auth/getUserProfile")
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile)
  },
  methods: {
    checkMobile() {
      const wasMobile = this.isMobile
      this.isMobile = window.innerWidth <= 820
      if (this.isMobile && !wasMobile) {
        this.sidebarOpen = false
      } else if (!this.isMobile && wasMobile) {
        this.sidebarOpen = true
      }
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    }
  }
}
</script>

<style scoped>
.layout-background {
  background-color: #f0f5f3;
}
</style>
